<link
  crossorigin=""
  href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"
  integrity="sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY="
  rel="stylesheet"
/>
<div class="main-page">
  <app-main-layout />
</div>
